module.exports = __webpack_public_path__ + "staticVue/img/logo.9675d7ee.png";